import { jsPDF } from "jspdf";
import "jspdf-autotable";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { getUser, handleMessageElaborated } from "../utils/Common";

// Utilidad para formatear los datos según las columnas exportables
export const formatExportData = (data, columns) => {
  return data.map(row => {
    const formattedRow = {};
    columns.forEach(col => {
      if (col.Cell) {
        formattedRow[col.Header] = col.Cell({ value: row[col.accessor] });
      } else {
        formattedRow[col.Header] = row[col.accessor];
      }
    });
    // Copia propiedades auxiliares como rowColor
    Object.keys(row).forEach(key => {
      if (!(columns.some(col => col.accessor === key))) {
        formattedRow[key] = row[key];
      }
    });
    return formattedRow;
  });
};

// Exportar a PDF
export const exportToPDF = async ({
  data,
  columns,
  filename = "reporte",
  nameReport = "Reporte",
  roleId,
  showSucursal
}) => {
  const formattedData = formatExportData(data, columns);
  const tableColumnHeaders = Object.keys(formattedData[0]);
  const isLandscape = tableColumnHeaders.length > 10;

  const doc = new jsPDF({
    orientation: isLandscape ? "landscape" : "portrait",
    unit: "px",
    format: "a4",
  });

  let logo = new window.Image();
  logo.src = "/img/logo-correos.png";
  const logoWidth = 110;
  const logoHeight = 40;
  const pageWidth = doc.internal.pageSize.getWidth();
  const logoX = pageWidth - 40 - logoWidth;
  doc.addImage(logo, "PNG", logoX, 20, logoWidth, logoHeight);

  doc.setFont("Helvetica", "bold");
  doc.setFontSize(20);
  const titleX = 40;
  doc.text(nameReport.toUpperCase(), titleX, 40);

  const fecha = new Date();
  const sucursal = `${getUser().CodigoEstafeta} ${getUser().NombreEstafeta}`;
  const usuario = getUser().Usuario;
  const fechaStr = fecha.toLocaleDateString("es-ES", { weekday: "long", year: "numeric", month: "long", day: "numeric" });
  const horaStr = fecha.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit", hour12: true });

  doc.setFont("Helvetica", "normal");
  doc.setFontSize(9);
  let infoY = 70;
  const lineSpacing = 10;

  // Mostrar sucursal si showSucursal es true o no está definido (por defecto se muestra)
  if (typeof showSucursal === "undefined" || showSucursal) {
    doc.text(`Estafeta: ${sucursal}`, 40, infoY);
    infoY += lineSpacing;
  }
  doc.text(`Fecha de Reporte: ${fechaStr}`, 40, infoY);
  infoY += lineSpacing;
  doc.text(`Hora: ${horaStr}`, 40, infoY);
  infoY += lineSpacing;
  doc.text(`Usuario: ${usuario}`, 40, infoY);

  let excelInfoRows = [];
  if (typeof showSucursal === "undefined" || showSucursal) {
    excelInfoRows.push([`Estafeta: ${sucursal}`]);
  }
  excelInfoRows.push([`Fecha de Reporte: ${fechaStr}`]);
  excelInfoRows.push([`Hora: ${horaStr}`]);
  excelInfoRows.push([`Usuario: ${usuario}`]);


  const tableRows = formattedData.map(row => Object.values(row));

  let totals = [];
  /*
  if (includeTotals) {
    totals = Array(tableColumnHeaders.length).fill("");
    for (let col = tableColumnHeaders.length - 4; col < tableColumnHeaders.length; col++) {
      let total = 0;
      tableRows.forEach(row => {
        const value = parseFloat(row[col]?.replace("B/.", "").trim() || 0);
        if (!isNaN(value)) total += value;
      });
      totals[col] = `B/. ${total.toFixed(2)}`;
    }
  }*/

  const noteRow = Array(tableColumnHeaders.length).fill("");
  noteRow[0] = "Nota: Los colaboradores son responsables de todas las actividades realizadas con su cuenta de usuario en el sistema y deben asegurarse de que este documento sea utilizado exclusivamente por Correos Panamá.";

  const contactRow = Array(tableColumnHeaders.length).fill("");
  contactRow[0] = "www.correospanama.gob.pa | Síguenos en: @correospma | Teléfonos: 512-7657 | WhatsApp: 6980-1551";

  const coloredRowIndices = [];
    data.forEach((row, idx) => {
    if (row.rowColor) {
        coloredRowIndices.push(idx);
    }
    });

  let isLastPage = false;
    doc.autoTable({
    head: [tableColumnHeaders],
    body: [...tableRows, totals, noteRow, contactRow],
    startY: infoY + 20,
    styles: { fontSize: 8, cellPadding: 1, halign: "center" },
    headStyles: { fillColor: [15, 67, 114], textColor: [255, 255, 255], fontStyle: "bold" },
    bodyStyles: { lineColor: [0, 0, 0], lineWidth: 0.5 },
    theme: "grid",
            didDrawPage: (data) => {
             
                const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
                const totalPages = doc.internal.getNumberOfPages();
                isLastPage = currentPage === totalPages;

              
                if (!isLastPage) {
                    doc.addImage(logo, "PNG", logoX, 20, logoWidth, logoHeight);
                    doc.setFont("Helvetica", "bold");
                    doc.setFontSize(20); 
                    doc.text(nameReport.toUpperCase(), titleX, 40);
                }
    },
    didParseCell: (data) => {
    if (coloredRowIndices.includes(data.row.index)) {
        const colorHex = data.row.raw && data.row.raw.rowColor
        ? data.row.raw.rowColor
        : data.rowColor || data.cell.raw?.rowColor;
        if (colorHex) {
        const rgb = [
            parseInt(colorHex.substring(0, 2), 16),
            parseInt(colorHex.substring(2, 4), 16),
            parseInt(colorHex.substring(4, 6), 16)
        ];
        data.cell.styles.fillColor = rgb;
        }
        // Color de fuente
        const fontColorHex = data.row.raw && data.row.raw.rowFontColor;
        if (fontColorHex) {
        const rgbFont = [
            parseInt(fontColorHex.substring(0, 2), 16),
            parseInt(fontColorHex.substring(2, 4), 16),
            parseInt(fontColorHex.substring(4, 6), 16)
        ];
        data.cell.styles.textColor = rgbFont;
        }
    }
        if (data.row.index === tableRows.length) {
        data.cell.styles.fontStyle = "bold";
        data.cell.styles.fillColor = [242, 242, 242];
        }
        if (data.row.index === tableRows.length + 1) {
        data.cell.styles.fontStyle = "italic";
        data.cell.styles.textColor = [100, 100, 100];
        data.cell.colSpan = tableColumnHeaders.length;
        }
        if (data.row.index === tableRows.length + 2) {
        data.cell.styles.fontStyle = "bold";
        data.cell.styles.textColor = [15, 67, 114];
        data.cell.colSpan = tableColumnHeaders.length;
        }
    },
    });

  const finalY = doc.lastAutoTable.finalY + 15;
  doc.setDrawColor(0, 0, 0);
  const lineStartX = 40;
  const lineWidth = 200;
  doc.line(lineStartX, finalY, lineStartX + lineWidth, finalY);

  doc.setFontSize(9);
  const message = await handleMessageElaborated(getUser());
  doc.text(`Generado por: ${getUser().NombreSimple} ${getUser().ApellidoSimple}, ${message}`, 40, finalY + 10);

  doc.save(`${filename}.pdf`);

};

// === CONSTANTES Y UTILIDADES ===
const COLORS = {
  header: 'ffd500',
  headerFont: '000000',
  infoBg: '0F4372',
  infoFont: 'FFFFFF',
  noteBg: 'F2F2F2',
  noteFont: '000000',
  contactBg: '0F4372',
  contactFont: 'FFFFFF',
  border: '000000',
};

const TEXTS = {
  note: "Nota: Los colaboradores son responsables de todas las actividades realizadas con su cuenta de usuario en el sistema y deben asegurarse de que este documento sea utilizado exclusivamente por Correos Panamá.",
  contact: "www.correospanama.gob.pa | Síguenos en: @correospma | Teléfonos: 512-7657 | WhatsApp: 6980-1551",
};

function getExcelColName(n) {
  let s = '';
  while (n > 0) {
    let m = (n - 1) % 26;
    s = String.fromCharCode(65 + m) + s;
    n = Math.floor((n - m) / 26);
  }
  return s;
}

function formatDate(date = new Date()) {
  return date.toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
}
function formatTime(date = new Date()) {
  return date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', hour12: true });
}

function setWorksheetHeaderInfo(worksheet, numColumns, getUser) {
  const fillColor = COLORS.infoBg;
  const user = getUser();
  const mostrarSucursal = !(user.roleId >= 4);

  let filaActual = 6;
  let filasHeader = mostrarSucursal ? 4 : 3;
  let filaSucursal = mostrarSucursal ? filaActual : null;

  for (let row = 6; row < 6 + filasHeader; row++) {
    for (let col = 1; col <= numColumns; col++) {
      const cell = worksheet.getCell(row, col);
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: fillColor },
      };
      cell.border = {};
    }
  }

  if (mostrarSucursal) {
    worksheet.getCell(filaActual, 1).value = "Sucursal:";
    worksheet.getCell(filaActual, 2).value = user.CodigoEstafeta + ' ' + user.NombreEstafeta;
    filaActual++;
  }
  worksheet.getCell(filaActual, 1).value = "Fecha de Reporte:";
  worksheet.getCell(filaActual, 2).value = formatDate();
  filaActual++;
  worksheet.getCell(filaActual, 1).value = "Hora:";
  worksheet.getCell(filaActual, 2).value = formatTime();
  filaActual++;
  worksheet.getCell(filaActual, 1).value = "Usuario:";
  worksheet.getCell(filaActual, 2).value = user.Usuario;

  // Formato de fuente y alineación
  for (let row = 6; row < 6 + filasHeader; row++) {
    for (let col = 1; col <= 2; col++) {
      const cell = worksheet.getCell(row, col);
      cell.font = {
        bold: col === 1,
        color: { argb: COLORS.infoFont },
        size: 11,
        name: 'Arial',
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: col === 1 ? 'right' : 'left',
      };
    }
  }
}

function setWorksheetFooter(worksheet, numColumns, getUser, message) {

  const lastRow = worksheet.lastRow.number + 5; 
  const colEnd = getExcelColName(numColumns);

  worksheet.mergeCells(`A${lastRow}:${colEnd}${lastRow}`);
  worksheet.getCell(`A${lastRow}`).value = TEXTS.note;
  worksheet.getCell(`A${lastRow}`).alignment = { vertical: 'middle', horizontal: 'center' };
  worksheet.getCell(`A${lastRow}`).fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: COLORS.noteBg },
  };
  worksheet.getCell(`A${lastRow}`).font = { color: { argb: COLORS.noteFont } };

  worksheet.mergeCells(`A${lastRow + 1}:${colEnd}${lastRow + 1}`);
  worksheet.getCell(`A${lastRow + 1}`).value = TEXTS.contact;
  worksheet.getCell(`A${lastRow + 1}`).alignment = { vertical: 'middle', horizontal: 'center' };
  worksheet.getCell(`A${lastRow + 1}`).fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: COLORS.contactBg },
  };
  worksheet.getCell(`A${lastRow + 1}`).font = { color: { argb: COLORS.contactFont } };

  const firmaRow = lastRow + 6; 
  const mensajeRow = lastRow + 7; 

  const generatedByCell = worksheet.getCell(`A${firmaRow}`);
  generatedByCell.value = `Generado por: ${getUser().NombreSimple} ${getUser().ApellidoSimple}`;
  generatedByCell.border = { top: { style: 'thin', color: { argb: COLORS.border } } };

  worksheet.getCell(`A${mensajeRow}`).value = message;
}

// Exportar a Excel
export const exportToExcel = async ({
  data,
  columns,
  filename = "reporte",
  nameReport = "Reporte",
  roleId,
  minTotalWidth = 200
}) => {
  try {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(nameReport.toUpperCase());
    const formattedData = formatExportData(data, columns);
    worksheet.columns = Object.keys(formattedData[0]).map(key => ({ key, width: 20 }));
    const numColumns = Object.keys(formattedData[0]).length;
    // --- Imagen: NO TOCAR ---
    const imagePath = '/img/logo-correos.png';
    const response = await fetch(imagePath);
    const imageBlob = await response.blob();
    const imageBase64 = await new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(imageBlob);
      reader.onloadend = () => {
        resolve(reader.result.split(',')[1]);
      };
    });
    const imageId = workbook.addImage({
      base64: imageBase64,
      extension: 'png',
    });

    worksheet.addImage(imageId, {
      tl: { col: 0, row: 1 },
      ext: { width: 230, height: 80 },
      editAs: 'absolute',
    });

    const colEnd = getExcelColName(numColumns);
    const titleRange = `A3:${colEnd}3`;
    worksheet.mergeCells(titleRange);
    const reportTextCell = worksheet.getCell('A3');
    reportTextCell.value = nameReport.toUpperCase();
    reportTextCell.font = { size: 20, bold: true };
    reportTextCell.alignment = { vertical: 'middle', horizontal: 'center' };
    reportTextCell.border = undefined;
    worksheet.getRow(10).values = Object.keys(formattedData[0]);
    formattedData.forEach((row, index) => {
      worksheet.addRow({ ...row, __rowNum__: index + 11 });
    });
    formattedData.forEach((row, index) => {
      if (row.rowColor || row.rowFontColor) {
        const excelRow = worksheet.getRow(index + 11);
        excelRow.eachCell((cell) => {
          if (row.rowColor) {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: row.rowColor } };
          }
          if (row.rowFontColor) {
            cell.font = { ...cell.font, color: { argb: row.rowFontColor } };
          }
        });
      }
    });
    worksheet.getRow(10).eachCell((cell) => {
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: COLORS.header } };
      cell.font = { bold: true, color: { argb: COLORS.headerFont } };
    });
    worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (rowNumber >= 1 && rowNumber <= 3) {
          cell.border = undefined;
          return;
        }
        cell.border = {
          top: { style: 'thin', color: { argb: COLORS.border } },
          left: { style: 'thin', color: { argb: COLORS.border } },
          bottom: { style: 'thin', color: { argb: COLORS.border } },
          right: { style: 'thin', color: { argb: COLORS.border } },
        };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });
    });
    worksheet.columns.forEach(column => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const columnLength = cell.value ? cell.value.toString().length : 10;
        if (columnLength > maxLength) {
          maxLength = columnLength;
        }
      });
      column.width = maxLength < 10 ? 10 : maxLength;
    });

    let anchoTotal = worksheet.columns.reduce((acc, col) => acc + col.width, 0);

    if (anchoTotal < minTotalWidth) {
        const extraPorColumna = (minTotalWidth - anchoTotal) / worksheet.columns.length;
        worksheet.columns.forEach(col => {
            col.width += extraPorColumna;
        });
    }
    worksheet.autoFilter = {
      from: 'A10',
      to: `${colEnd}10`,
    };
    setWorksheetHeaderInfo(worksheet, numColumns, getUser);
    const message = await handleMessageElaborated(getUser());
    setWorksheetFooter(worksheet, numColumns, getUser, message);
    worksheet.getColumn('A').width = Math.max(worksheet.getColumn('A').width, 40);
    worksheet.getColumn('B').width = Math.max(worksheet.getColumn('B').width, 30);
    worksheet.getColumn('C').width = Math.max(worksheet.getColumn('C').width, 20);
    worksheet.getColumn('D').width = Math.max(worksheet.getColumn('D').width, 30);
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, `${filename}.xlsx`);
  } catch (e) {
    console.error('Error exportando a Excel:', e);
  }
};

export const exportMultipleTablesToExcel = async ({
  tables,
  filename = "reporte",
  minColumnWidth = 25,
  minTotalWidth = 200
}) => {
  try {
    const workbook = new ExcelJS.Workbook();
    // --- Imagen: NO TOCAR ---
    const imagePath = '/img/logo-correos.png';
    const response = await fetch(imagePath);
    const imageBlob = await response.blob();
    const imageBase64 = await new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(imageBlob);
      reader.onloadend = () => {
        resolve(reader.result.split(',')[1]);
      };
    });
    const imageId = workbook.addImage({
      base64: imageBase64,
      extension: 'png',
    });

 for (const table of tables) {
  const { nameReport, columns, data } = table;
  if (!data || data.length === 0) continue; 

  const worksheet = workbook.addWorksheet(nameReport.toUpperCase());
  const formattedData = formatExportData(data, columns);

  worksheet.columns = Object.keys(formattedData[0]).map(key => ({
    key: key,
    width: Math.max(20, minColumnWidth), 
  }));

  const numColumns = Object.keys(formattedData[0]).length;

    worksheet.addImage(imageId, {
      tl: { col: 0, row: 1 },
      ext: { width: 230, height: 80 },
      editAs: 'absolute',
    });

    const colEnd = getExcelColName(numColumns);
    const titleRange = `A3:${colEnd}3`;
    worksheet.mergeCells(titleRange);

    const reportTextCell = worksheet.getCell('A3');
    reportTextCell.value = nameReport.toUpperCase();
    reportTextCell.font = { size: 20, bold: true };
    reportTextCell.alignment = { vertical: 'middle', horizontal: 'center' };
    reportTextCell.border = undefined;
    worksheet.getRow(10).values = Object.keys(formattedData[0]);
    

    // Agregar filas de datos
    formattedData.forEach((row, index) => {
      worksheet.addRow({
        ...row,
        __rowNum__: index + 11
      });
    });

    // Colorear filas especiales
    formattedData.forEach((row, index) => {
      if (row.rowColor || row.rowFontColor) {
        const excelRow = worksheet.getRow(index + 11);
        excelRow.eachCell((cell) => {
          if (row.rowColor) {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: row.rowColor },
            };
          }
          if (row.rowFontColor) {
            cell.font = {
              ...cell.font,
              color: { argb: row.rowFontColor },
            };
          }
        });
      }
    });

    worksheet.getRow(10).eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: COLORS.header },
      };
      cell.font = {
        bold: true,
        color: { argb: COLORS.headerFont },
      };
    });

    worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
        row.eachCell({ includeEmpty: true }, (cell, colNumber) => {

        if (rowNumber >= 1 && rowNumber <= 5) {
            cell.border = undefined;
            return;
        }

        cell.border = {
            top: { style: 'thin', color: { argb: COLORS.border } },
            left: { style: 'thin', color: { argb: COLORS.border } },
            bottom: { style: 'thin', color: { argb: COLORS.border } },
            right: { style: 'thin', color: { argb: COLORS.border } },
        };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        });
    });

    worksheet.columns.forEach(column => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const columnLength = cell.value ? cell.value.toString().length : 10;
        if (columnLength > maxLength) {
          maxLength = columnLength;
        }
      });
      column.width = Math.max(maxLength, minColumnWidth);
    });

    let anchoTotal = worksheet.columns.reduce((acc, col) => acc + col.width, 0);

    if (anchoTotal < minTotalWidth) {
        const extraPorColumna = (minTotalWidth - anchoTotal) / worksheet.columns.length;
        worksheet.columns.forEach(col => {
            col.width += extraPorColumna;
        });
    }

    worksheet.autoFilter = {
      from: 'A10',
      to: `${colEnd}10`,
    };

    // Cabecera de sucursal, fecha, usuario, etc.
    setWorksheetHeaderInfo(worksheet, numColumns, getUser);

    // Pie de página
    const message = await handleMessageElaborated(getUser());
    setWorksheetFooter(worksheet, numColumns, getUser, message);

    worksheet.getColumn('A').width = Math.max(worksheet.getColumn('A').width, 40);
    worksheet.getColumn('B').width = Math.max(worksheet.getColumn('B').width, 30);
    worksheet.getColumn('C').width = Math.max(worksheet.getColumn('C').width, 20);
    worksheet.getColumn('D').width = Math.max(worksheet.getColumn('D').width, 30);
  /*
    worksheet.eachRow({ includeEmpty: true }, (row) => {
      row.eachCell({ includeEmpty: true }, (cell) => {
        if (!cell.value && !cell.fill) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFF' },
          };
        }
      });
    });*/

  }

  // Guardar archivo
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  saveAs(blob, `${filename}.xlsx`);
} catch (e) {
    console.error('Error exportando múltiples tablas a Excel:', e);
  }
};

// Exportar múltiples tablas a PDF, una debajo de otra
export const exportMultipleTablesToPDF = async ({
  tables,
  filename = "reporte",
  nameReport = "Reporte General"
}) => {
  const { jsPDF } = await import("jspdf");
  const doc = new jsPDF({ unit: "px", format: "a4" });

  // Logo y cabecera general
  let logo = new window.Image();
  logo.src = "/img/logo-correos.png";
  const logoWidth = 110;
  const logoHeight = 40;
  const pageWidth = doc.internal.pageSize.getWidth();
  const logoX = pageWidth - 40 - logoWidth;
  doc.addImage(logo, "PNG", logoX, 20, logoWidth, logoHeight);

  doc.setFont("Helvetica", "bold");
  doc.setFontSize(20);
  const titleX = 40;
  doc.text(nameReport.toUpperCase(), titleX, 40);

  const fecha = new Date();
  const usuarioObj = getUser();
  const sucursal = `${usuarioObj.CodigoEstafeta} ${usuarioObj.NombreEstafeta}`;
  const usuario = usuarioObj.Usuario;
  const fechaStr = fecha.toLocaleDateString("es-ES", { weekday: "long", year: "numeric", month: "long", day: "numeric" });
  const horaStr = fecha.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit", hour12: true });

  doc.setFont("Helvetica", "normal");
  doc.setFontSize(9);
  let infoY = 70;
  const lineSpacing = 10;

  if (usuarioObj.roleId < 4) {
    doc.text(`Estafeta: ${sucursal}`, 40, infoY);
    infoY += lineSpacing;
  }
  doc.text(`Fecha de Reporte: ${fechaStr}`, 40, infoY);
  infoY += lineSpacing;
  doc.text(`Hora: ${horaStr}`, 40, infoY);
  infoY += lineSpacing;
  doc.text(`Usuario: ${usuario}`, 40, infoY);

  let currentY = infoY + 20;

  for (let i = 0; i < tables.length; i++) {
    const { nameReport: tableTitle, columns, data } = tables[i];
    if (!data || data.length === 0) continue;

    // Título de la tabla
    doc.setFont("Helvetica", "bold");
    doc.setFontSize(16);
    doc.text(tableTitle.toUpperCase(), 40, currentY);
    currentY += 20;

    // Preparar datos
    const formattedData = formatExportData(data, columns);
    const columnsDef = columns;
    const autoTableColumns = columnsDef.map(col => ({
      header: col.Header,
      dataKey: col.Header
    }));
    const tableRows = formattedData;

    function hexToRgb(hex) {
      hex = hex.replace(/^#/, '');
      if (hex.length === 3) {
        hex = hex.split('').map(x => x + x).join('');
      }
      while (hex.length < 6) hex = '0' + hex;
      const bigint = parseInt(hex, 16);
      if (isNaN(bigint)) return null;
      return {
        r: (bigint >> 16) & 255,
        g: (bigint >> 8) & 255,
        b: bigint & 255
      };
    }

    doc.autoTable({
      columns: autoTableColumns,
      body: tableRows,
      startY: currentY,
      styles: { fontSize: 8, cellPadding: 1, halign: "center" },
      headStyles: { fillColor: [15, 67, 114], textColor: [255, 255, 255], fontStyle: "bold" },
      bodyStyles: { lineColor: [0, 0, 0], lineWidth: 0.5 },
      theme: "grid",
      margin: { left: 40, right: 40 },
      didParseCell: (data) => {
        try {
          const rawData = data.row.raw;
          if (!rawData || typeof rawData !== 'object') return;
    
          const rowColor = rawData.rowColor || rawData.ROWCOLOR || rawData['row-color'];
          const rowFontColor = rawData.rowFontColor || rawData.ROWFONTCOLOR || rawData['row-font-color'];
    
          if (rowColor) {
            const rgb = hexToRgb(rowColor);
            if (rgb) {
              data.cell.styles.fillColor = [rgb.r, rgb.g, rgb.b];
              data.cell.styles.fontStyle = 'bold'; 
            }
          }
    
          if (rowFontColor) {
            const rgb = hexToRgb(rowFontColor);
            if (rgb) {
              data.cell.styles.textColor = [rgb.r, rgb.g, rgb.b];
            }
          }
        } catch (error) {
          console.warn('Error al aplicar estilos de fila:', error);
        }
      }
    });
    currentY = doc.lastAutoTable.finalY + 30;
  }

  // Pie de página, notas, etc.
  const finalY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 15 : currentY + 15;
  doc.setDrawColor(0, 0, 0);
  const lineStartX = 40;
  const lineWidth = 200;
  doc.line(lineStartX, finalY, lineStartX + lineWidth, finalY);

  doc.setFontSize(9);
  const message = await handleMessageElaborated(getUser());
  doc.text(`Generado por: ${getUser().NombreSimple} ${getUser().ApellidoSimple}, ${message}`, 40, finalY + 10);

  doc.save(`${filename}.pdf`);
};